<script>
export default {
  data() {
    return {
      activeName: '0',
      list: [
        {
          title:'跨設備',
          content: '<p>使用各種裝置（手機、平板、電腦）皆可使用</p>'
        },
        {
          title:'專屬官網',
          content: '再也不需要花錢建構官方網站，連動預約服務的官網，讓你行銷點數滿滿加分！'
        },
        {
          title:'線上金流開通',
          content: '不再需要申請刷卡機，即可透過愛寵訂服務進行刷卡！'
        },
        {
          title:'Line線上預約',
          content: '<p>串連官方 Line，讓客戶輕鬆預約輕鬆購買各項包月與儲值！</p>'
        },
        {
          title:'寵物安親',
          content: '<p>獨家配套安親模組，即將上線。</p>'
        },
        {
          title:'寵物住宿',
          content: '<p>專屬住宿模組，打造您的寵物旅館！即將上線。</p>'
        },
      ]
    }
  }
}
</script>

<template>
  <div :class="$style.sectionSecondary">
    <div class="section container">
      <div class="row sectionSecondary__list">
        <div class="col-xl-5 col-12 sectionSecondary__item">
          <div class="sectionSecondary__item--left">
            <BaseSectionTitle 
              title="為您的服務帶來專業優勢" 
              sub-title="Become a Pro" 
              class="isStyleDecoration mx-lg-0 islgCenter mx-auto text-lg-left text-center"
            />
            <el-collapse v-model="activeName" accordion class="sectionSecondary__collapse isStyleBase">
              <el-collapse-item 
               v-for="(item,$index) in list"
               :key="$index"
               :name="`${$index}`"
               >
                <template slot="title">
                  <div v-html="item.title">
                  </div>
                </template>
                <div v-html="item.content"></div>
              </el-collapse-item>
            </el-collapse>
          </div>
          
        </div>
        <div class="col-xl-7 col-12 sectionSecondary__item--right d-xl-none">
          <!-- <img 
            class="bg"
            src="~@assets/images/home/section7-image.png" alt=""
          > -->
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.sectionSecondary {
  position: relative;
  &:after {
    content: '';
    position: absolute;
    top: 135px;
    right: 0;
    background-image: url('@assets/images/home/section7-image.png');
    background-repeat: no-repeat;
    background-size: cover;
    width: 50%;
    padding-bottom: 46%;
    display: none;
    @media screen and (max-width: 1500px) {
      padding-bottom: 67%;
    } 
    @media screen and (min-width: 2300px) {
      width: 1145px;
      padding-bottom: 0;
      height: 100%;
    }
    @include min-xl {
      display: block;
    }
  }
  :global {
    .sectionSecondary{

      &__item {
        &--left {

        }
        &--right {
          background-image: url('~@assets/images/home/section7-image.png');
          background-repeat: no-repeat;
          background-size: cover;
          width: 100%;
          padding-bottom: 91%;
          position: relative;
          right: 0;
          padding-left: 0;
          margin-top: 44px;
          overflow: hidden;
          @media
            only screen and (-webkit-min-device-pixel-ratio: 2),
            only screen and (   min--moz-device-pixel-ratio: 2),
            only screen and (     -o-min-device-pixel-ratio: 2/1),
            only screen and (        min-device-pixel-ratio: 2),
            only screen and (                min-resolution: 192dpi),
            only screen and (                min-resolution: 2dppx) { 
              background-image: url('~@assets/images/home/section7-image@2x.png');
            }
        }
      }
      &__collapse {
        // margin-top: 105px;
      }
    }
    .el-collapse {
      &.isStyleBase {
        border-top: 0;
        border-bottom: 0;
        .el-collapse-item {
          border: 1px solid rgba(237, 240, 244, 1);
          border-radius: 20px;
          margin-top: 20px;
          padding-left: 36px;
          padding-right: 36px;
          &.is-active {
            background: #FCFCFC;
            .el-collapse-item__header {
              background: #FCFCFC;
            }
            .el-collapse-item__wrap {
              background: #FCFCFC;
            }
          }
          @include max-md {
            padding-left: 24px;
            padding-right: 24px;
          }
          &__header {
            font-size: 18px;
            font-weight: 600;
            height: 70px;
            line-height: 1.75;
            border-bottom: 0;
            &.is-active {
              background: rgba(233, 235, 247, 0.15)
            }
            &:before {
              content: '\e904';
              color: $color-primary;
              font-family: 'icomoon';
              padding-right: 10px;
            }
          }
          &__wrap {
            border-bottom: 0;
          }
          &__arrow {
            &:before {
              color: #9C9FB0;
              content: '\e910';
              font-family: 'icomoon';
            }
            &.is-active {
              transform: none;
              &:before {
                content: '\e90b';
                font-family: 'icomoon';
                
              }
            }
          }
        }
      }
    }
  }
}
</style>